import React, { useState } from "react";
import * as RB from "react-bootstrap";

function PostInstallationTable({
  checklistData,
  setChecklistData,
  saftyChecklistData,
  setsaftyChecklistData,
  isDisable,
}) {
  const handleInputChange = (index, field, value) => {
    const updatedChecklist = [...checklistData];
    updatedChecklist[index][field] = value;
    setChecklistData(updatedChecklist);
  };

  const handleSaftyInputChange = (index, field, value) => {
    const updatedChecklist = [...saftyChecklistData];
    updatedChecklist[index][field] = value;
    setsaftyChecklistData(updatedChecklist);
  };

  return (
    <RB.Container>
      <h6 className="mt-3">Post Installation Check List</h6>
      <div className="table-responsive">
        <RB.Table bordered className="mt-3">
          <thead>
            <tr>
              <th>Parameters / Particulars</th>
              <th>Conclusion of Check List</th>
              <th>Remarks</th>
              <th>Signature</th>
            </tr>
          </thead>
          <tbody>
            {checklistData.map((row, index) => (
              <tr key={index}>
                <td>{row.parameter}</td>
                <td>
                  <RB.Form.Control
                    type="text"
                    value={row.conclusion}
                    disabled={isDisable}
                    onChange={(e) =>
                      handleInputChange(index, "conclusion", e.target.value)
                    }
                  />
                </td>
                <td>
                  <RB.Form.Control
                    type="text"
                    value={row.remarks}
                    disabled={isDisable}
                    onChange={(e) =>
                      handleInputChange(index, "remarks", e.target.value)
                    }
                  />
                </td>
                <td>
                  <RB.Form.Control
                    disabled={isDisable}
                    type="text"
                    value={row.signature}
                    onChange={(e) =>
                      handleInputChange(index, "signature", e.target.value)
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </RB.Table>
      </div>
      <h6 className="mt-3">Safety Post Installation Check List</h6>
      <div className="table-responsive">
        <RB.Table bordered className="mt-3">
          <thead>
            <tr>
              <th>Parameters / Particulars</th>
              <th>Conclusion of Check List</th>
              <th>Remarks</th>
              <th>Signature</th>
            </tr>
          </thead>
          <tbody>
            {saftyChecklistData.map((row, index) => (
              <tr key={index}>
                <td>{row.parameter}</td>
                <td>
                  <RB.Form.Control
                    type="text"
                    value={row.conclusion}
                    onChange={(e) =>
                      handleSaftyInputChange(
                        index,
                        "conclusion",
                        e.target.value
                      )
                    }
                    disabled={isDisable}
                  />
                </td>
                <td>
                  <RB.Form.Control
                    type="text"
                    value={row.remarks}
                    onChange={(e) =>
                      handleSaftyInputChange(index, "remarks", e.target.value)
                    }
                    disabled={isDisable}
                  />
                </td>
                <td>
                  <RB.Form.Control
                    type="text"
                    value={row.signature}
                    onChange={(e) =>
                      handleSaftyInputChange(index, "signature", e.target.value)
                    }
                    disabled={isDisable}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </RB.Table>
      </div>
    </RB.Container>
  );
}

export default PostInstallationTable;
